import React, { useState } from 'react'
import { Flex } from '@ui'

interface AccordionProps {
  data: [
    {
      toolbar: JSX.Element
      content: JSX.Element
      disabled?: boolean
    }
  ]
  onChange?: (index: number, isOpen: boolean) => void
  selIndx?: number
  single?: boolean
  showAllFlag?: boolean
}

export default function (props: AccordionProps) {
  const [state, setState] = useState(
    (props.selIndx !== undefined ? [props.selIndx] : []) as number[]
  )

  return (
    <Flex direction="column">
      {props.data.map((d, i) => (
        <div>
          <div
            onClick={() => {
              const indx = state.findIndex((j) => j === i)
              if (props.single) {
                if (state[0]) {
                  props.onChange?.(i, false)
                  state.splice(0)
                }
                state[0]
              } else {
                if (indx > -1) {
                  state.splice(i, 1)
                  props.onChange?.(i, false)
                } else {
                  state.push(i)
                  props.onChange?.(i, true)
                }
              }
              setState([...state])
            }}>
            {d.toolbar}
          </div>
          {(state.includes(i) || !props.showAllFlag) && <div>{d.content}</div>}
        </div>
      ))}
    </Flex>
  )
}
